import { render, staticRenderFns } from "./details_visit_canada.vue?vue&type=template&id=372d9d23&"
import script from "./details_visit_canada.vue?vue&type=script&lang=js&"
export * from "./details_visit_canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports